module.exports = __webpack_public_path__ + "static/29-9fcff3430af6e86f131eed915e5a3d0d.jpg";